import script from "./RegisterView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterView.vue?vue&type=script&setup=true&lang=js"

import "./RegisterView.vue?vue&type=style&index=0&id=7f48ced9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f48ced9"]])

export default __exports__